<template>
    <div>
        <vx-tooltip :text="$t('apps.configurator.stage-button-tooltip')" position="top" delay=".3s" class="m-0">
            <vs-button type="border" class="mr-2 px-3 rounded-lg" @click="askStageVersion">
                <div class="flex flex-nowrap">
                    <svg width="26" height="26" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_flask)">
                            <path
                                d="M8.5 4V9L4 17.5C3.7 18.1 4.1 18.8 4.8 18.8H17.2C17.9 18.8 18.3 18.1 18 17.5L13.5 9V4"
                                stroke="#3560DA" stroke-width="1.6" stroke-miterlimit="10" stroke-linejoin="round" />

                            <path
                                d="M7 4H15"
                                stroke="#3560DA" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round" />

                            <path
                                d="M6.5 14.5H15.5"
                                stroke="#3560DA" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_flask">
                                <rect width="22" height="22" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </vs-button>
        </vx-tooltip>

        <ModalInfo :modalOpen=modalOpen :type=modalType :headingText=headingModalText :text=modalText
            @closedModal="modalOpen = false" />
    </div>
</template>
<script>
import ConfiguratorVersionService from '@/modules/Apps/Services/Configurator/ConfiguratorVersionService'
import ModalInfo from '@/modules/Shared/Components/modal/ModalInfo.vue'
import loader from "@/modules/Shared/Mixins/loader";

export default {
    name: 'configurator-stage-button',
    mixins: [
        loader
    ],
    components: {
        ModalInfo
    },
    props: {
        properties: { type: Object, required: true }
    },
    data() {
        return {
            modalOpen: false,
            headingModalText: "",
            modalText: "",
            modalType: "",
        }
    },
    methods: {
        async askStageVersion() {
            this.$vs.dialog({
                type:'confirm',
                color:'primary',
                title: this.$t("apps.configurator.confirm-stage-title"),
                text: this.$t("apps.configurator.confirm-stage-message"),
                accept: () => this.releaseVersion()
            })
        },
        async releaseVersion() {
            let that = this
            this.loadAndNotifyError(async function () {
                let checkResponse = await ConfiguratorVersionService.checkStatusVersion(that.properties.uuid)
                if (checkResponse.status_code !== 200 || checkResponse.description.status === 'ERROR') {
                    that.modalType = 'danger'
                    that.headingModalText = that.$t("apps.configurator.version.release.ko")
                    that.modalText = Object.entries(checkResponse.description.errors).reduce((acc, error) => {
                        return `${acc}\n ${error[1]}`
                    }, "")
                    that.modalOpen = true
                    return
                }
                let response = await ConfiguratorVersionService.releaseVersion(that.properties.uuid, 'stage')
                if (response.status_code == 201) {    
                    that.modalType = "success"
                    that.headingModalText = that.$t("apps.configurator.version.release.ok")
                    that.modalText = ''
                } else {
                    that.modalType = 'danger'
                    that.headingModalText = that.$t("apps.configurator.version.release.ko")
                    that.modalText = Object.entries(response.description).reduce((acc, error) => {
                        return `${acc}\n ${error[1]}`
                    }, "")
                }
                that.modalOpen = true
            })
        }
    }
}
</script>

<style scoped>
.action-button button {
    @apply h-12 !important;
}</style>
